<template>
  <div>
    <LocationContact
      v-for="location in locations"
      :key="location.name"
      :location="location"
    />
  </div>
</template>

<script>
/* eslint-disable no-param-reassign */
/* eslint-disable max-len */

import LocationContact from './LocationContact';

export default {
  name: 'LocationContacts',

  components: {
    LocationContact,
  },

  computed: {
    locations() {
      return this.$store.getters.filteredLocations;
    },
  },
};
</script>
